import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/card-back.png'
import _imports_1 from '@/assets/images/form/line.png'
import _imports_2 from '@/assets/images/play/bt-start.png'


const _hoisted_1 = { class: "Play" }
const _hoisted_2 = { class: "play-image" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "play-image" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card-image",
  alt: ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  class: "line-top",
  src: _imports_1
}, null, -1)
const _hoisted_33 = { class: "bt_play" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, "Pick a Card เลือกแตะที่ไพ่ 1 ใบที่ทัชใจคุณ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoSmall = _resolveComponent("LogoSmall")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LogoSmall, { class: "min-h" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_4),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_6),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_8),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_10),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_12),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_14),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_16)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_19),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_21),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_23),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_25),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_27),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_29),
      _createElementVNode("div", {
        class: "card",
        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.SelectCard && _ctx.SelectCard(...args)))
      }, _hoisted_31)
    ]),
    _hoisted_32,
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      (_ctx.btActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "bt-start",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.StartPlay && _ctx.StartPlay(...args)))
          }, _hoisted_36))
        : _createCommentVNode("", true)
    ])
  ]))
}